module.exports = __webpack_public_path__ + "static/media/address-c.c3388e6d.svg";